// Token por página (POST /sessoes/pagina-token): o cliente só diz o slug da página (VITE_PAGINA); quem decide
// usuário e escopo é o servidor. Token de curta validade, só em memória da aba: recarregar = pedir outro.

// Chaves do token antigo (localStorage, rota /sessoes/token). Só são APAGADAS.
const LEGACY_TOKEN_KEYS = ['token_auth_bot', 'token_auth_bot_id', 'token_auth_bot_slug']

function parseJwtPayload(token) {
    if (!token || typeof token !== 'string') return null
    const parts = token.split('.')
    if (parts.length < 2) return null
    try {
        const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
        return JSON.parse(atob(payload + '='.repeat((4 - (payload.length % 4)) % 4)))
    } catch (_) {
        return null
    }
}

export function isTokenExpired(token, skewMs = 30000) {
    const payload = parseJwtPayload(token)
    if (!payload || !payload.exp) return true
    return Date.now() + skewMs >= payload.exp * 1000
}

/** `pagina` e `fetcher` entram por parâmetro para o teste rodar sem Vite nem rede. */
export function criarTokenDePagina({pagina, fetcher, storage = globalThis.localStorage}) {
    let token = ''
    let pedidoEmCurso = null

    async function pedir(slug) {
        const res = await fetcher('/sessoes/pagina-token', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({pagina: slug}),
        })
        if (!res.ok) throw new Error(`HTTP ${res.status}: falha ao obter token da página`)
        const novo = String((await res.json())?.token || '').replace(/^Bearer\s+/i, '')
        if (!novo) throw new Error('Token não retornado por /sessoes/pagina-token')
        return novo
    }

    return {
        /** Devolve o token da memória; pede outro se faltar, estiver perto de expirar ou `force`. */
        async obter(force = false) {
            if (!force && token && !isTokenExpired(token)) return token
            const slug = String(pagina() || '').trim().toLowerCase()
            if (!slug) throw new Error('Página não configurada. Defina VITE_PAGINA no build.')
            // Uma chamada só em voo: pedidos simultâneos dividem o mesmo token.
            if (!pedidoEmCurso) {
                pedidoEmCurso = pedir(slug)
                    .then((t) => (token = t))
                    .finally(() => {
                        pedidoEmCurso = null
                    })
            }
            return pedidoEmCurso
        },
        limpar() {
            token = ''
            try {
                LEGACY_TOKEN_KEYS.forEach((k) => storage.removeItem(k))
            } catch (_) {
                // storage indisponível (aba privada): sem efeito
            }
        },
    }
}

// apiBase só carrega na primeira chamada (usa import.meta.env no topo, que o Node dos testes não tem).
export const tokenDePagina = criarTokenDePagina({
    pagina: () => import.meta.env.VITE_PAGINA,
    fetcher: async (...args) => (await import('./apiBase')).apiFetch(...args),
})
